"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const config_1 = require("config");
const utils_1 = require("utils");
const forms_1 = require("../../forms");
function Applicants({ getCreditApplicationByToken }) {
    const history = (0, react_router_dom_1.useHistory)();
    const { search } = (0, react_router_dom_1.useLocation)();
    const query = (0, utils_1.parseQuery)(search);
    const token = query[config_1.QUERY_KEY.TOKEN];
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const handleSubmit = (formValues) => {
        setSubmitting(true);
        return getCreditApplicationByToken(formValues, token)
            .then(() => {
            handleSubmitSuccess();
        })
            .catch((error) => {
            (0, utils_1.toastError)((0, utils_1.apiErrorToErrorMessage)(error?.response?.errorCode, error?.response?.message));
        })
            .finally(() => {
            setSubmitting(false);
        });
    };
    const handleSubmitSuccess = () => {
        let nextActionURL;
        switch (query[config_1.QUERY_KEY.ACTION]) {
            case config_1.ACTION.CONTINUE:
                nextActionURL = config_1.CONTINUE_APPLICATION_URL;
                break;
            case config_1.ACTION.NEW_ACCESS_LOAN:
                nextActionURL = config_1.NEW_ACCESS_LOAN_URL;
                break;
            default:
                throw new Error(`Unknown applicant action [${query[config_1.QUERY_KEY.ACTION]}]`);
        }
        history.push((0, utils_1.makeQueryPath)(nextActionURL, query));
    };
    return ((0, jsx_runtime_1.jsxs)("section", { className: "applicant-container", children: [(0, jsx_runtime_1.jsxs)("header", { children: [(0, jsx_runtime_1.jsx)("h1", { children: "Identity Verification" }), (0, jsx_runtime_1.jsx)("p", { children: "Please provide the following information so we can confirm your identity before moving forward." })] }), (0, jsx_runtime_1.jsx)(forms_1.ApplicationFinderForm, { handleSubmit: handleSubmit, submitting: submitting })] }));
}
function mapStateToProps() {
    return {};
}
const mapDispatchToProps = {
    getCreditApplicationByToken: apiActions.getCreditApplicationByToken,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(Applicants);
